import { Dropdown } from "antd";
import type { DropDownProps } from "antd/es/dropdown";
import classNames from "classnames";
import React from "react";
import styles from "./index.less";
import { DropdownProps } from "antd/es/dropdown/dropdown";

export type HeaderDropdownProps = {
  overlayClassName?: string;
  placement?: DropdownProps["placement"];
} & Omit<DropDownProps, "overlay">;

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({
  overlayClassName: cls,
  ...restProps
}) => (
  <Dropdown
    overlayClassName={classNames(styles.container, cls)}
    {...restProps}
  />
);

export default HeaderDropdown;
